import { render, staticRenderFns } from "./Interstitial.vue?vue&type=template&id=747fe4f6&"
import script from "./Interstitial.vue?vue&type=script&lang=js&"
export * from "./Interstitial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports